/* eslint-disable import/prefer-default-export */
import ApiService from './ApiService';
import { getExternalNetworkService } from './externalNetworks';

class SenderService {
  static async getQuickResponses() {
    const composedURL = '/api3/fast_reply/';
    const response = ApiService.get(composedURL);
    return response;
  }

  static async getProperties(searchword) {
    const composedURL = `/api3/sender/search/?searchword=${searchword}`;
    const response = ApiService.get(composedURL);
    return response;
  }

  static async getPropertyFiles(propertyId) {
    const composedURL = `/api3/property/${propertyId}/quick/files?file_type=files`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getDevelopmentFiles(developmentId) {
    const composedURL = `/api3/development/${developmentId}/quick/files`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getParentDevelopmentFiles(developmentId) {
    const composedURL = `/api3/development/${developmentId}/quick/files`;
    const response = await ApiService.get(composedURL);

    return response;
  }

  static async getPropertiesFilesById(ids) {
    const composedURL = `/api3/property/files?file_type=files&properties=${ids}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getContactReports(contactId) {
    const composedURL = `/api3/owner/${contactId}/properties`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getPropertiesById(listOfPropertiesId) {
    const composedURL = `/api3/sender/property?ids=${listOfPropertiesId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  /**
   * Get properties by hash/identifier for external networks
   * @param {Array<string>|string} identifiers - List of property identifiers or comma-separated string
   * @param {string|null} outerNet - External network identifier
   * @returns {Promise} Properties data
   */
  static async getPropertiesByExternalNetwork(identifiers, outerNet) {
    const externalService = getExternalNetworkService(outerNet);
    if (!externalService) {
      throw new Error(`No service found for external network: ${outerNet}`);
    }
    const identifiersArray = Array.isArray(identifiers)
      ? identifiers
      : identifiers.split(',');
    return externalService.getPropertiesByIdentifiers(identifiersArray);
  }

  /**
   * @deprecated Use getPropertiesByExternalNetwork instead
   * Kept for backward compatibility
   */
  static async getPropertiesByHash(listOfPropertiesHash) {
    const externalService = getExternalNetworkService('opennavent');
    const identifiers = Array.isArray(listOfPropertiesHash)
      ? listOfPropertiesHash
      : listOfPropertiesHash.split(',');
    return externalService.getPropertiesByIdentifiers(identifiers);
  }

  static async getDevelopmentsById(listOfDevelopmentsId) {
    const composedURL = `/api3/sender/development?ids=${listOfDevelopmentsId}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getFichaInfoUrl(data) {
    const { id, contactId, isEdited, lang } = data;
    const composedURL = `/api3/property/get_ficha_info_url?properties_id=${id}&contact_id=${contactId}&is_edited=${isEdited}&lang=${lang}`;
    const response = await ApiService.get(composedURL);
    // Se agrega timestamp para evitar cache en OpenGraph
    const timestamp = new Date().getTime();
    response.ficha_info_url = `${response.ficha_info_url}?v=${timestamp}`;
    return response;
  }

  static async trackWhatsappMessage(data) {
    const composedURL = '/api3/timeline/wasap';
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async sendEmail(payload) {
    const composedURL = '/api3/contact/send_props_or_devs_to_contacts';
    const response = await ApiService.post(composedURL, payload);
    return response;
  }

  static async validateWhatsapp(number) {
    const composedURL = `/api3/twilio/validate_phone?phone=${number}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async replaceWhatsappMessage(data) {
    const composedURL = `/api3/fast_reply/replace_dynamic_tags/?contact_id=${
      data.contactId
    }&message=${encodeURIComponent(data.message)}`;
    const response = await ApiService.get(composedURL);
    return response;
  }
}

export default SenderService;
